<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <!-- FINANCIAL RESPONSIBILITY -->
                    <div>
                        <p class="font-weight-bold">F. FINANCIAL GOOD STANDING</p>
                    </div>
                    <div class="financial-responsibility">
                        <p>
                            Financial good standing and a university record clear of holds are required for students to
                            receive services. Upon course registration, students are required to sign a Financial
                            Responsibility Agreement that outlines all financial procedures, obligations, rights, and
                            responsibilities that are summarized below:
                            Services, including but not limited to access to courses, transcript issuance, diploma release,
                            class registration (add, drop, withdrawal, etc.), and/or housing, will be immediately suspended
                            for students with a financial balance due or a hold of any kind on their record. Course grades for
                            those students who have not completed their financial requirements until the end of the final
                            exam week will not be entered. If a student's account remains delinquent, BAU reserves the
                            right to terminate enrollment. Additionally, they will not be cleared to receive their official
                            transcripts or completion diplomas.
                            Failure to meet financial obligations to BAU will result in other collection procedures, which
                            include account referral to credit reporting bureaus, private collection agencies, DC Office of
                            Tax and Revenue, and Office of Attorney General. Past-due accounts are subject to
                            garnishments, liens and judgments, and the withholding of money from tax refunds. In addition
                            to late fees and interest, delinquent accounts will be assessed additional collection costs up to
                            thirty percent of the past due balance, reasonable attorney fees, and other administrative costs.
                            Once an account is referred to a collection agency, payment must be made to the agency, not
                            BAU.
                        </p>
                        <ul>

                            <li>
                                <strong>In Late Fee it should say:</strong>Failure to make any tuition payments on or before the module start date may result in an <strong>$80 late fee</strong> . The late fee will apply only to the tuition. Other fees (for example, activity fee, materials fee etc.) will be deducted before applying payment for tuition.
                            </li>
                            <li>
                                <strong>Return Check Fee:</strong> A <strong>$35 fee</strong> will be charged for each unpaid check returned by the bank.
                            </li>
                            <li>
                                <strong>Exceptional Cases:</strong> In the documented event of prolonged illness, accident, or death in the immediate family (parents, siblings, children, or spouse) or other exceptional circumstances that make it impractical to complete the program,
                                BAU will work toward a settlement that is reasonable and fair to both parties.
                            </li>
                        </ul>
                        <!-- Checkbox 1 -->
                        <ValidationProvider name="financialAgreement" rules="required" v-slot="{ errors }">
                            <b-form-checkbox
                                v-model="form.financialAgreement"
                                name="financialAgreement"
                                value="accepted"
                                unchecked-value=""
                            >
                                I confirm that the information given in this section is true, complete, and accurate (Financial Responsibility Agreement).
                            </b-form-checkbox>
                            <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                        </ValidationProvider>
                    </div>
                </b-col>

                <!-- F-1 RESPONSIBILITIES -->
                <b-col cols="12" class="mt-3">
                    <div class="f1-responsibilities">
                        <h4>F-1 RESPONSIBILITIES (FOR F-1 STUDENTS ONLY)</h4>
                        <p><strong>Understanding the terms and conditions of your F-1 nonimmigrant status</strong></p>
                        <p>To provide the DSO the timely information needed to maintain your SEVIS record, please:</p>

                        <ol>
                            <li>Enroll in a full course of study at the beginning of every session (excluding authorized break periods).</li>
                            <li>Notify if you intend to take an authorized vacation within the US.</li>
                            <li>Report US address, email address, and phone number changes within 10 days of the change (immigration requirement).</li>
                            <li>Report on any change in sources of financial support.</li>
                            <li>Notify prior traveling outside the US. If you go to your home country, you must contact the school at least 15 days before returning to the US.</li>
                            <li>Notify upon applying for change/adjustment of status including your dependents.</li>
                            <li>Request a timely extension (30 days before the expiration date of your I-20 Form) when you need more time to complete your program.</li>
                            <li>Comply with attendance and academic policies.</li>
                            <li>Do not work without authorization.</li>
                            <li>Do not drop a class without getting approval from a DSO.</li>
                            <li>Timely notify Admissions if you intend to transfer.</li>
                        </ol>

                        <!-- Checkbox 2 -->
                        <ValidationProvider name="f1Responsibilities" rules="required" v-slot="{ errors }">
                            <b-form-checkbox
                                v-model="form.f1Responsibilities"
                                name="f1Responsibilities"
                                value="accepted"
                                :unchecked-value="null"
                            >
                                I have read, understood, and agree to comply with the F1 Student Responsibilities mentioned above.
                            </b-form-checkbox>
                            <b-form-invalid-feedback v-if="errors[0]">{{ errors[0] }}</b-form-invalid-feedback>
                        </ValidationProvider>
                    </div>

                    <!-- Next Button -->
                    <b-col cols="12" class="text-md-right mt-3">
                        <b-button type="submit" @click="next" variant="primary" class="w-100 w-md-auto">
                            {{ $t('next') }}
                        </b-button>
                    </b-col>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>

</template>
<script>
export default {
    data() {
        return {
            form: {},
        }
    },
    created() {
        window.scrollTo(0,0)

    },

    methods: {
        async next(){
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid){
                this.$emit('next',1)
            }

        },
        back(){
            this.$emit('back', -1);
        }
    }
}
</script>
